import axios from "axios";
export default {
  namespaced: true,
  state: {
    benefits: [],
  },
  getters: {
    benefits(state) {
      return state.benefits;
    },
  },
  mutations: {
    SET_BENEFITS(state, benefits) {
      state.benefits = benefits;
    },
    ADD_BENEFIT(state, benefit) {
      state.benefits.unshift(benefit);
    },
    EDIT_BENEFIT(state, benefit) {
      var index = state.benefits.findIndex((a) => a.id == benefit.id);
      state.benefits.splice(index, 1, benefit);
    },
    DELETE_BENEFIT(state, benefit) {
      let filtered = state.benefits.filter((c) => {
        return c.id != benefit.id;
      });
      state.benefits = filtered;
    },
  },
  actions: {
    // get benefits
    async get_benefits({ commit }) {
      let response = await axios.get("/benefits");
      commit("SET_BENEFITS", response.data);
    },
    async add_benefit({ commit }, request) {
      let response = await axios.post("/benefit", request);
      commit("ADD_BENEFIT", response.data);
    },
    async edit_benefit({ commit }, request) {
      let response = await axios.put("/benefit", request);
      commit("EDIT_BENEFIT", response.data);
    },
    async delete_benefit({ commit }, request) {
      await axios.delete("/benefit/" + request.id);
      commit("DELETE_BENEFIT", request);
    },
  },
};
